import { getStore } from '../axiosInstance';
import { logout } from '../../../../app/store/slices/authSlice';
import { addToast } from '../../../../app/store/slices/uiSlice';

export const setupResponseInterceptor = (axiosInstance) => {
  axiosInstance.interceptors.response.use(
    (response) => {
      // Log response time in development
      if (process.env.NODE_ENV === 'development' && response.config.metadata) {
        const duration = new Date() - response.config.metadata.startTime;
      }

      return response;
    },
    (error) => {
      const store = getStore();
      const status = error.response?.status;
      const message = error.response?.data?.message || error.message;

      // Handle different error status codes
      switch (status) {
        case 401:
          // Unauthorized - token expired or invalid
          console.warn('[API 401] Unauthorized - Logging out');
          if (store) {
            store.dispatch(logout());
            store.dispatch(addToast({
              type: 'error',
              title: 'Session Expired',
              message: 'Please login again to continue.',
            }));
          }
          // Redirect to login
          window.location.href = '/login';
          break;

        case 403:
          // Forbidden - no permission
          console.warn('[API 403] Forbidden');
          if (store) {
            store.dispatch(addToast({
              type: 'error',
              title: 'Access Denied',
              message: 'You do not have permission to perform this action.',
            }));
          }
          break;

        case 404:
          // Not found
          console.warn('[API 404] Not Found:', error.config?.url);
          break;

        case 422:
          // Validation error
          console.warn('[API 422] Validation Error:', message);
          if (store) {
            store.dispatch(addToast({
              type: 'warning',
              title: 'Validation Error',
              message: message || 'Please check your input and try again.',
            }));
          }
          break;

        case 500:
        case 502:
        case 503:
        case 504:
          // Server errors
          console.error('[API Server Error]', status, message);
          if (store) {
            store.dispatch(addToast({
              type: 'error',
              title: 'Server Error',
              message: 'Something went wrong. Please try again later.',
            }));
          }
          break;

        default:
          // Network error or other errors
          if (!error.response) {
            console.error('[API Network Error]', error.message);
            if (store) {
              store.dispatch(addToast({
                type: 'error',
                title: 'Network Error',
                message: 'Please check your internet connection.',
              }));
            }
          }
          break;
      }

      // Log error in development
      if (process.env.NODE_ENV === 'development') {
        console.error('[API Error]', {
          status,
          message,
          url: error.config?.url,
          method: error.config?.method,
        });
      }

      return Promise.reject(error);
    }
  );
};
